// src/pages/Welcome/useWelcomeData.js
import { useEffect, useState, useMemo } from 'react';
import fetchListings from '../../utils/fetchListings';

export const useWelcomeData = () => {
  const [listings, setListings] = useState([]);
  const [filters, setFilters] = useState({ category: '', minPrice: '', maxPrice: '' });
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('newest');
  const [allListings, setAllListings] = useState([]);
  const [loading, setLoading] = useState(true);

  // Map sort option to Firestore orderBy/orderDir
  const sortParams = useMemo(() => {
    switch (sort) {
      case 'priceLow':
        return { orderBy: 'price', orderDir: 'asc' };
      case 'priceHigh':
        return { orderBy: 'price', orderDir: 'desc' };
      case 'newest':
      default:
        return { orderBy: 'createdAt', orderDir: 'desc' };
    }
  }, [sort]);

  // Fetch all listings, with filters and sort
  useEffect(() => {
    const loadListings = async () => {
      const data = await fetchListings({
        category: filters.category || null,
        minPrice: filters.minPrice && filters.minPrice !== "" ? Number(filters.minPrice) : null,
        maxPrice: filters.maxPrice && filters.maxPrice !== "" ? Number(filters.maxPrice) : null,
        ...sortParams,
      });
      setListings(data);
      setAllListings(data);
      setLoading(false);
    };
    loadListings();
  }, [filters, sortParams]);

  // Filter listings by search (title only, case-insensitive)
  const filteredListings = search
    ? allListings.filter((l) =>
        l.title && l.title.toLowerCase().includes(search.toLowerCase())
      )
    : listings;

  return {
    listings,
    filters,
    setFilters,
    search,
    setSearch,
    sort,
    setSort,
    filteredListings,
    loading
  };
};